<template>
  <div class="section4-container">
    <div class="box">
      <div class="wrapper">
        <div class="wrapper-head">
          {{ $t("message.section4.title") }}
        </div>
        <div class="wrapper-body">
          <div class="row m-0 t1">
            <div class="col-6 col-sm-3">
              <img src="@images/sponsor/01.png" />
            </div>
            <div class="col-6 col-sm-3">
              <img src="@images/sponsor/02.png" />
            </div>
            <div class="col-6 col-sm-3">
              <img src="@images/sponsor/03.png" />
            </div>
            <div class="col-6 col-sm-3">
              <img src="@images/sponsor/04.png" />
            </div>
          </div>
          <div class="row m-0 t2 justify-content-center">
            <div class="col-4 col-lg-3">
              <img src="@images/sponsor/05.png" />
            </div>
            <div class="col-4 col-lg-3">
              <img src="@images/sponsor/06.png" />
            </div>
            <div class="col-4 col-lg-3">
              <img src="@images/sponsor/07.png" />
            </div>
            <div class="col-4 col-lg-3">
              <img src="@images/sponsor/08.png" />
            </div>
            <div class="col-4 col-lg-3">
              <img src="@images/sponsor/09.png" />
            </div>
            <div class="col-4 col-lg-3">
              <img src="@images/sponsor/10.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "section4"
};
</script>

<style lang="scss" scoped>
@import "@scss/home/section4.scss";
</style>